import { TDeviceType } from '@cian/ui-kit';
import { TPageType } from '../../common/types/applicationContext';

export enum SiteType {
  Table = 'tablet',
  Desktop = 'desktop',
  Mobile = 'mobile',
}

export type DefaultAnalyticsPayload = {
  user: Record<'userId', number | null>;
  name: string;
  category: 'calculator';
  action: string;
  label: string;
  page: {
    pageType: 'offerCalculator' | 'subsidizedCalculator';
    siteType: SiteType;
    extra?: Record<string, unknown>;
  };
};

export type TrackEventArgs = Pick<DefaultAnalyticsPayload, 'action' | 'label'> & {
  extra?: DefaultAnalyticsPayload['page']['extra'];
  user?: DefaultAnalyticsPayload['user'];
};

export type TServiceInitArgs = {
  deviceType: TDeviceType;
  pageType: TPageType;
  userId: number | null;
};
